import { FlagsManager } from '@databases/flags-types';

export class NoOpFlagsManager extends FlagsManager {
  addFlag(): void {}

  handleFlagDismiss(): void {}

  clearFlags(): void {}

  showFlag(): void {}

  hideFlag(): void {}

  hideAllFlags(): void {}
}
